// extracted by mini-css-extract-plugin
module.exports = {"AuthForm":"style_AuthForm__1iIES"};